import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';

/**
 * Operator-Cluster-Dashboard (#7). GET /v1/hosting-ops/clusters (orbit-backend
 * → Nexus /v1/pod-clusters/capacity). Zeigt aktive Cluster + freie Kapazität
 * (allocatable minus Pod-Requests) + Pod-Anzahl.
 */
export function usePodClusters() {
  const { fetch } = useApiClient();
  return useQuery({
    queryKey: ['pod-clusters-capacity'],
    queryFn: () => fetch('/v1/hosting-ops/clusters'),
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
}
